import type { CellProps, IStatusMap, LinePaymets } from '../../../interfaces'
import type { FC } from 'react'

import Avoid from '../../Button/Avoid'
import Rebuild from '../../Button/Rebuild'
import Preloader from '../../Preloader/Preloader'
import type { ISure } from '../../../types'
export interface IButtonPropsGrid extends CellProps {
  record?: LinePaymets
  choseSure?: (fileNames: string, groupNumber: string, type: string, entId: string) => void
  eventAvoid?: (key: string) => void
  eventRebuild?: (key: string) => void
  sure?: ISure
  mapStatus?: IStatusMap
  pendingAvoid?: boolean
}

const ButtonCell: FC<IButtonPropsGrid> = ({
  record,
  eventAvoid,
  sure,
  choseSure,
  mapStatus,
  pendingAvoid,
  eventRebuild
}) => {
  const isSure = (): boolean => {
    return sure?.fileNames === record?.filenamesList
  }

  const checkStatusLocal = (): string => {
    const color: string[] = []
    for (const key in mapStatus) {
      const value = mapStatus[key]
      if (value?.includes(Number(record?.status))) {
        color.push(key)
      }
    }

    return color[0] ?? ''
  }
  return (
    <>
      {pendingAvoid === true && isSure() ? (
        <Preloader />
      ) : (
        <div className='custom-cell custom-cell__button'>
          {eventAvoid !== undefined &&
            record !== undefined &&
            choseSure !== undefined &&
            checkStatusLocal() === 'pending' &&
            pendingAvoid !== undefined && (
              <Avoid
                record={record}
                isSure={isSure() && sure?.type === 'Avoid'}
                choseSure={choseSure}
                eventVoid={eventAvoid}
                isPending={pendingAvoid}
              />
            )}
          {record?.buildAvailable &&
            eventRebuild !== undefined &&
            record !== undefined &&
            choseSure !== undefined &&
            pendingAvoid !== undefined && (
              <Rebuild
                record={record}
                isSure={isSure() && sure?.type === 'Rebuild'}
                choseSure={choseSure}
                eventRebuild={eventRebuild}
                isPending={pendingAvoid}
              />
            )}
        </div>
      )}
    </>
  )
}

export default ButtonCell
